module.exports = __webpack_public_path__ + "img/funding-rate.1c5e0e0b.jpg";